import { Tab, Tabs } from '@material-ui/core'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { PageTabsBar } from 'app/components/generic/PageLayout'
import { navigationPaths } from 'app/config'

import Enrolment from './Enrolment/Enrolment'
import ExcelEnrolment from './ExcelEnrolment/ExcelEnrolment'
import ExploreEnrolment from './ExploreEnrolment/ExploreEnrolment'
import MakeUpSession from './MakeUpSession/ShowMakeUpSession/MakeUpSession'
import PSACEnrolment from './PSACEnrolment/PSACEnrolment'
import ToddlerClubEnrolment from './ToddlerClubEnrolment/ToddlerClubEnrolment'
import TrialSessions from './TrialSessions/TrialSessions'

const TAB_BY_PATH = {
  [navigationPaths.enrolment]: 'event',
  [navigationPaths.excelEnrolment]: 'excel',
  [navigationPaths.exploreEnrolment]: 'explore',
  [navigationPaths.psacEnrolment]: 'schoolCare',
  [navigationPaths.toddlerClubEnrolment]: 'toddlerClub',
  [navigationPaths.trialEnrolment]: 'trial',
  [navigationPaths.makeupEnrolment]: 'makeup'
}

const PATH_BY_TAB = {
  event: navigationPaths.enrolment,
  excel: navigationPaths.excelEnrolment,
  explore: navigationPaths.exploreEnrolment,
  schoolCare: navigationPaths.psacEnrolment,
  toddlerClub: navigationPaths.toddlerClubEnrolment,
  trial: navigationPaths.trialEnrolment,
  makeup: navigationPaths.makeupEnrolment
}

const TAB_COMPONENT = {
  event: Enrolment,
  excel: ExcelEnrolment,
  explore: ExploreEnrolment,
  schoolCare: PSACEnrolment,
  toddlerClub: ToddlerClubEnrolment,
  trial: TrialSessions,
  makeup: MakeUpSession
}

const Enrolments = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const currentTab = TAB_BY_PATH[pathname] || 'event'

  const handleTabChange = (_, value) => {
    if (value !== currentTab) history.push(PATH_BY_TAB[value])
  }

  const TabComponent = TAB_COMPONENT[currentTab]

  return (
    <>
      <PageTabsBar>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          <Tab label="Event" value="event" />
          <Tab label="Excel" value="excel" />
          <Tab label="Explore" value="explore" />
          <Tab label="School & Care" value="schoolCare" />
          <Tab label="Toddler Club" value="toddlerClub" />
          <Tab label="Trial & Drop-In" value="trial" />
          <Tab label="Make-Up" value="makeup" />
        </Tabs>
      </PageTabsBar>
      <TabComponent />
    </>
  )
}

export default Enrolments
